export const changePlanProgressSteps = ['Choose plan', 'Review', 'Pay']

export const highlight = {
  upgrade: {
    title: 'This {{changeTypePastTense}} plan is on us for the rest of this month.',
    copy: 'Your new {{name}} {{speed}} plan will kick in within the next couple of hours.',
  },
  downgrade: {
    title: 'Your {{speed}} plan will kick in {{startDateWithPreposition}}',
    copy: '',
  },
}
